<template>
    <div>
        <h3>Plan <router-link :to="'/admin/planView/' + project.planId">{{ project.planName }}</router-link></h3>
        <h2>Group <router-link :to="'/admin/groupView/' + project.groupId">{{ project.groupName }}</router-link></h2>
        <h1>Project</h1>
        <form id="search" @submit="updateProject">
            <label for="name">{{ $t("admin.adminProjectView.name") }}: </label><input id="name" name="name" v-model="project.name"><br/>
            <label for="description">{{ $t("admin.adminProjectView.description") }}: </label><textarea id="description" name="description" v-model="project.description"></textarea><br/>
            <label for="enabled">{{ $t("admin.adminProjectView.enabled") }}: </label><input id="enabled" name="enabled" v-model="project.enabled" type="checkbox"><br/>

            <input type="submit" class="submit" v-bind:value="$t('admin.adminProjectView.button.update')">
        </form>
        <AdminProjectDelete v-bind:project="project" />
    </div>
</template>

<script>
    import { adminService } from '@/services/admin.service'
    import AdminProjectDelete from "./AdminProjectDelete";

    export default {
        name: 'AdminProjectView',
        components: {AdminProjectDelete},
        data: function() {
            return {
                project: {}
            };
        },
        created: function() {
            this.fetchData();
        },
        methods: {
            fetchData: function () {
                adminService.projectGet(this.$route.params.projectId).then((data) => {
                    this.project = data;
                    if(data.description){
                        this.project.description = decodeURIComponent(atob(data.description))
                    }
                }).catch((err) => {
                    console.error('Unable to get project: ', err)
                });
            },
            updateProject: function(e) {
                e.preventDefault();
                let tmpProjectData = JSON.parse(JSON.stringify(this.project))
                tmpProjectData.description = btoa(encodeURIComponent(this.project.description))

                adminService.projectUpdate(this.$route.params.projectId, tmpProjectData).then(() => {
                    this.fetchData();
                }).catch((err) => {
                    console.error('Unable to update project: ', err)
                });
            }
        }
    }
</script>
